import { render, staticRenderFns } from "./TextConfig.vue?vue&type=template&id=a503ee48&scoped=true&"
import script from "./TextConfig.vue?vue&type=script&lang=js&"
export * from "./TextConfig.vue?vue&type=script&lang=js&"
import style0 from "./TextConfig.vue?vue&type=style&index=0&id=a503ee48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a503ee48",
  null
  
)

export default component.exports